export default {
    payouts(state)
    {
        return state.payouts
    },
    loading(state)
    {
        return state.loading
    },
    total(state)
    {
        return state.total
    }
}
